import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TagTypeable } from './tag-typeable.interface';
import tagTypeableService from './tag-typeable.service';

export interface TagTypeableState { }

const TagTypeableStore: Module<TagTypeableState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async delete(context, { tag_typeable_id, property_type_id }: { tag_typeable_id: number; property_type_id: number }) {
         return await tagTypeableService.delete(tag_typeable_id).then((response: TagTypeable) => {
            context.commit('board/removeTagTypeFromBoard', response.tagType.tag_type_id, { root: true });
            context.commit('pool/removeTagTypeFromPool', response.tagType.tag_type_id, { root: true });

            context.dispatch(
               'propertyType/patches',
               { property_type_id, patches: [{ path: 'has_automatic_tags', value: false }] },
               { root: true },
            );
            return response;
         });
      },
   },
};

export default TagTypeableStore;
